import { useId } from 'react';

import { Label } from 'cpool-components/general/Label';
import { DropdownMenu } from 'cpool-components/input/DropdownMenu';
import { useTranslation } from 'react-i18next';

const HOUSEHOLD_OPTIONS = ['SHARED', 'SEPARATE'] as const;

type HouseholdOption = (typeof HOUSEHOLD_OPTIONS)[number];

type Props = {
    applicant: 1 | 2;
    onChange: (sharedHousehold: boolean) => void;
    sharedHousehold: boolean;
    disabled?: boolean;
};

export const SharedHouseholdSelect = ({ applicant, disabled, onChange, sharedHousehold }: Props) => {
    const { t } = useTranslation();
    const labelId = useId();

    const options = HOUSEHOLD_OPTIONS.map((option) => ({
        label: t(`LIVING_SITUATION_DATA.HAUSHALT.HOUSEHOLD_OPTIONS.${option}`),
        value: option,
    }));

    return (
        <div className="flex items-start gap-2.5">
            <Label className="h-8 w-[175px] shrink-0 justify-start" id={labelId}>
                {t('LIVING_SITUATION_DATA.HAUSHALT.HOUSEHOLD_MANAGEMENT')}
            </Label>
            <DropdownMenu<HouseholdOption>
                aria-labelledby={labelId}
                data-testid={`antragsteller${applicant}.wohnsituation.gemeinsamerHaushalt`}
                options={options}
                value={sharedHousehold ? 'SHARED' : 'SEPARATE'}
                onChange={(value) => onChange(value === 'SHARED')}
                matchTriggerWidth
                triggerClassName="w-full justify-between"
                className="w-full"
                disabled={disabled}
            />
        </div>
    );
};
